module.exports = __webpack_public_path__ + "static/media/listBack.07d457ab.png";